module.exports = __webpack_public_path__ + "92e49a70ceb4ffb1949765eed7764544.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/K@2x.png
// module id = 826
// module chunks = 0